<template>
    <div class="activityDetail">
        <van-nav-bar title="活动详情" left-arrow @click-left="backChange1" />
        <div class="activityBanner">
            <img :src="dataSources.activity_cover" alt="">
        </div>
        <div class="activityTitle">
            <span>{{ dataSources.activity_name }}</span>
            <div class="activityTime">
                活动周期：{{ dataSources.start_time }} - {{ dataSources.end_time }}
            </div>
        </div>
        <div class="activityTab">
            <div class="activityTabItem" @click='selectTab(1)'>
                <span :class="[selectType == 1 ? '' : 'disable']">活动说明</span>
                <dd v-if="selectType == 1"></dd>
            </div>
            <div class="activityTabItem" @click='selectTab(2)'>
                <span :class="[selectType == 2 ? '' : 'disable']">学习计划</span>
                <dd v-if="selectType == 2"></dd>
            </div>


        </div>

        <div class="activityHtml" v-if="selectType == 1">
            <p v-html="dataSources.activity_description" style="background-color: #fff;">
            </p>
        </div>


        <div v-if="selectType == 2" class="activityDes">
            <div v-for="(item, index) in dataSources.list" :key="index" class="teacherContent">
                <div class="teacherTitle"><span>讲师：{{ item.lecturer_name }}</span></div>
                <div class="courseContent" v-for="(itemC, indexC) in item.course_list" :key="indexC">
                    <div class="courseL">课程：</div>
                    <div class="courseR">{{ itemC }}</div>
                </div>
            </div>

        </div>

        <div v-if="dataSources.button_state == 1 || dataSources.button_state == 3 || dataSources.button_state == 2 || dataSources.button_state == 4 || dataSources.button_state == 6"
            :class="[dataSources.button_state == 2 ? 'disableBtn' : 'actionBtn']" @click.stop="activeBtnClick()">
            <span>{{ setStateString(dataSources.button_state) }}</span>
        </div>

        <!-- <div v-if="dataSources.button_state == 5" class="singedBtn">
                    <span>完成当日签到</span>
                </div> -->
        <div v-if="dataSources.button_state == 7" @click.stop="evaluateBtnClick(dataSources.button_state)"
            class="actionBtn">
            <span>查看评价</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'activityDetail',
    data() {
        return {
            dataSources: {},
            selectType: 1,
        };
    },
    mounted() {
        this.getData();

    },
    created() {
    },
    methods: {
        evaluateBtnClick() {
            this.$router.push({
                path: '/activity/evaluatePage',
                query: {
                    activity_id: this.dataSources.activity_id,
                    isEdit: 0
                }
            });
        },
        backChange1() {
            this.$router.go(-1);
        },
        // 下课签到
        endSign() {
            this.$api.homePage.endSign({
                activity_id: this.dataSources.activity_id
            }).then(res => {
                if (res.success) {
                    this.$message.success('签到成功');
                    this.getData();
                }
            });
        },
        // 上课签到
        startSign() {
            this.$api.homePage.startSign({
                activity_id: this.dataSources.activity_id
            }).then(res => {
                if (res.success) {
                    this.$message.success('签到成功');
                    this.getData();
                }
            });
        },
        // 立即参与
        singIn() {
            this.$api.homePage.joinActivity({
                activity_id: this.dataSources.activity_id
            }).then(res => {
                if (res.success) {
                    this.$message.success('签到成功');
                    this.getData();
                }
            });
        },
        // 点击详情
        activeBtnClick() {
            if (this.dataSources.button_state == 1) {
                // 立即参与
                this.singIn()
            } else if (this.dataSources.button_state == 3) {
                let idAuthStatus = this.$store.state.userInfo.idAuthStatus
                if (idAuthStatus == 0) {
                    this.$toast('请先实名认证');
                    this.$router.push({
                        path: '/idcard'
                    });
                    return;
                }
                this.startSign();
            } else if (this.dataSources.button_state == 4) {
                this.endSign();
            } else if (this.dataSources.button_state == 6) {
                   // 满意度评价
                   this.$router.push({
                    path: '/activity/evaluatePage',
                    query: {
                        activity_id: this.dataSources.activity_id,
                        isEdit: 1
                    }
                });
            }
        },
        setStateString(button_state) {
            /*
                    button_state = 1;//显示:立即参与 
                    button_state = 2;//显示:上课签到(置灰)
                    button_state = 3;//显示:上课签到
                    button_state = 4;//显示:下课签到
                    button_state = 5;//显示:完成当日签到(纯文字)
                    button_state = 6;//显示:满意度评价
                    button_state = 7;//显示:查看评价
                    button_state = 8;//显示:(不展示按钮)
            */
            if (button_state == 1) {
                return '立即参与';
            } else if (button_state == 2) {
                return '上课签到';
            } else if (button_state == 3) {
                return '上课签到';
            } else if (button_state == 4) {
                return '下课签到';
            } else if (button_state == 5) {
                return '完成当日签到';
            } else if (button_state == 6) {
                return '满意度评价';
            } else if (button_state == 7) {
                return '查看评价';
            } else if (button_state == 8) {
                return '';
            }

        },
        selectTab(type) {
            this.selectType = type;
        },
        async getData() {
            let params = {
                activity_id: this.$route.query.activity_id
            };
            const res = await this.$api.learningPage.activeDetail(params);
            if (res.success) {
                this.dataSources = res.data;
            }
        }
    },
};
</script>
<style lang="less">
::v-deep {
    .van-nav-bar__title {
        font-size: 16px;
        color: #333333;
    }

    .van-nav-bar {
        width: 100%;
        margin-bottom: 32px;
    }
}
</style>
<style lang="stylus">


.activityHtml{
    width: 100%;
    background-color:#fffff;
    margin-bottom: 120px;
    p{
        width: 100%;
        padding 36px 32px;
        box-sizing border-box;
        p{
            img{
                max-width: 686px;
                width 100%!important
                height auto
            
            }
        }
    }
    
}
</style>

<style scoped lang="stylus">
::v-deep {
    .van-nav-bar__title {
        font-size: 16px;
        color: #333333;
    }

    .van-nav-bar {
        width: 100%;
        margin-bottom: 32px;
    }
}
.disableBtn{
    width: 686px;
    height: 88px;
    background: #F3F3F3;
    border-radius: 48px;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 88px;
    text-align: center;
    position fixed;
    bottom: 20px;
}
.actionBtn{
    width: 686px;
    height: 88px;
    background: linear-gradient(164deg, #5EC9FF 0%, #498BFD 100%);
    border-radius: 48px;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
    position fixed;
    bottom: 20px;

}
.activityDetail{
    min-height 100vh
    padding-bottom 100px
    background: #F7F7F7;
    box-sizing border-box
    display flex
    flex-direction column
    align-items center
    width 100%
    .activityBanner{
        width 100%
        height auto
        img{
            width 100%
            height auto
            object-fit contain
        }
    }
    .activityTitle{
        width 100%;
        height 170px;
        span{
            display block;
            font-size: 32px;
            font-family: PingFangSC, PingFang SC;
             font-weight: 500;
             color: #333333;
             line-height: 46px;
             height: 46px;
             overflow hidden
             text-overflow ellipsis
             white-space nowrap
             width: 686px;
        }
        background: #FFFFFF;
        padding 0 30px;
        box-sizing border-box;
        padding-top 28px;

    }
    .activityTime{
        height: 24px;
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        margin-top: 24px;
    }
}

.activityTab{
    width: 100%;
    height: 100px;
    background: #FFFFFF;
    margin-top: 16px;
    display flex;
    flex-direction row;
    align-items center;

}
.activityTabItem{
    min-width: 112px;
    height: 100px;
    display flex;
    flex-direction column;
    margin-right: 80px;
    padding 0 40px;
    dd{
        min-width: 52px;
        height: 6px;
        background: #2E7BFF;
        border-radius: 3px;
        margin-top: 16px;
        align-self: center;
    }
    span{
        width: 112px;
        height: 36px;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        white-space: nowrap;
        line-height: 36px;
        margin-top: 33px;
    }
    .disable{
        color: #666666;
        font-weight: 400;
    }
}
.activityHtml{
    width: 100%;
    background-color:#fffff;
    p{
        width: 100%;
        padding 36px 32px;
        box-sizing border-box;
        p{
            img{
                max-width: 686px;
                width 100%!important
                height auto
            
            }
        }
        img{
            max-width: 686px;
            width 100%!important
            height auto
        }
    }
    
}
.activityDes{
    width:100%;
    background-color:#FBFBFB;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 120px;

    }
.teacherContent{
    width: 686px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 24px;
    .teacherTitle{
        width: 686px;
        height 88px
        border-bottom 1px solid #F2F2F2;
        display flex
        align-items center
        padding 0 24px
        box-sizing border-box
        font-size: 26px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 88px
        margin-bottom: 7px;
        overflow hidden;
        text-overflow ellipsis;
        white-space nowrap;
        span{
            width: 686px;
            overflow hidden;
            text-overflow ellipsis;
            white-space nowrap;

        }

    }
    .courseContent{
        width 100%
        padding 24px
        box-sizing border-box
        display flex
        .courseL{
            width: 100px;
            height: 28px;
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 28px;
        }
        .courseR{
            flex: 1;
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 28px;
        }
        

    }
}

</style>
